import { memo, useRef, useEffect } from "react";
import { PointIconName } from "PosterEditor/model/poster-types";
import {
  PointDrawingConfig,
  SVGIcons,
  IconSizeDefault,
} from "./point-icon-drawing/point-icon-drawing";

interface PointIconProps {
  iconName: PointIconName;
  color: string;
  secondaryColor?: string;
  size?: number; // Width/height of icon (aspect ratio is always 1).
}

export const PointIcon = memo((props: PointIconProps) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const size = props.size ?? IconSizeDefault;
  const scale = size / IconSizeDefault;

  useEffect(() => {
    const canvas = canvasRef.current;

    if (canvas) {
      const scaleFactor = 2;
      canvas.width = size * scaleFactor;
      canvas.height = size * scaleFactor;

      canvas.style.width = `${size}px`;
      canvas.style.height = `${size}px`;
      const ctx = canvas.getContext("2d");
      if (ctx && SVGIcons[props.iconName]) {
        const config: PointDrawingConfig = {
          ctx,
          color: props.color,
          secondaryColor: props.secondaryColor,
          scale: (scale ?? 1) * scaleFactor,
        };
        SVGIcons[props.iconName].draw(config);
      }
    }
  }, [props.color, props.iconName, props.size]);

  return <canvas ref={canvasRef}></canvas>;
});
